import React from "react";
import RoutingRule from "../../../../assets/svg/routing/routingRule.svg";
import HelpImage1 from "../../../../assets/svg/routing/helpModalImages/helpImg1.svg";
import HelpImage2 from "../../../../assets/svg/routing/helpModalImages/helpImg2.svg";
import HelpImage3 from "../../../../assets/svg/routing/helpModalImages/helpImg3.svg";
import HelpImage4 from "../../../../assets/svg/routing/helpModalImages/helpImg4.svg";
import HelpImage5 from "../../../../assets/svg/routing/helpModalImages/helpImg5.svg";
import HelpImage6 from "../../../../assets/svg/routing/helpModalImages/helpImg6.svg";
import HelpImage7 from "../../../../assets/svg/routing/helpModalImages/helpImg7.svg";
import { Dialog, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

function HelpModal({ isOpen, setIsOpen }) {
    const handleKeyDownFallback = (event) => {
        if (event.key === "Escape") {
            setIsOpen(false);
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={() => setIsOpen(false)}
            PaperProps={{
                style: {
                    backgroundColor: "#FFF",
                    borderRadius: "12px",
                    maxWidth: "1050px",
                },
            }}
            onKeyDown={handleKeyDownFallback}
        >
            <div className="p-3">
                <div className="d-flex align-items-start" style={{ gap: 10 }}>
                    <div style={{ width: "50px" }}>
                        <RoutingRule color="#403E9F" height={32} width={32} />
                    </div>
                    <div >
                        <div className="d-flex align-items-center justify-content-between">

                            <Typography className="headerH2Medium font-black-highest">
                                Create Custom Rule Based Routing
                            </Typography>
                            <Close
                                onClick={() => setIsOpen(false)}
                                style={{ cursor: "pointer" }}
                            />

                        </div>
                        <Typography
                            className="bodyB2RegularText mt-1"
                            style={{ color: "#4F4D55" }}
                        >
                            A comprehensive guide to create custom rule based routing
                        </Typography>
                        <Typography className="headerH3Medium mt-2">
                            Rule Creation
                        </Typography>
                        <ol style={{ listStyleType: "decimal" }} className="mt-2 p-0">
                            <Typography component="li" className="bodyB2RegularText">
                                <p className="my-1">
                                    To get started with creating custom rule, you need to enter the
                                    rule name for easy identification and reference, then select the
                                    business unit for which you wish to apply the rule for.
                                </p>
                                <p className="text-center my-3">
                                    <HelpImage1 />
                                </p>
                            </Typography>
                            <Typography component="li" className="bodyB2RegularText">
                                <p className="my-1">Next select a “Field” as per your business requirement or to
                                    optimize payment traffic flow. Click on the field input and
                                    select any required parameter such as card type, wallet, payment
                                    method and so on as shown below.
                                </p>

                                <p className="text-center my-3">
                                    <HelpImage2 />
                                </p>
                                <p className="my-1">List of “Fields” and their possible values are given below. </p>
                                <p className="text-center my-3">
                                    <HelpImage3 />
                                </p>
                            </Typography>
                            <Typography component="li" className="bodyB2RegularText">
                                <p className="my-1">Select an operator for the field selected. Depending on the field selected, the operator value me vary. The list of operators corresponding to the field is shown below in the table.
                                </p>

                                <p className="text-center my-3">
                                    <HelpImage4 />
                                    3                         <HelpImage5 />
                                </p>
                            </Typography>
                            <Typography component="li" className="bodyB2RegularText">
                                <p className="my-1">
                                    Make complex rules with ease by adding more conditions as shown in the image below.                                </p>

                                <p className="text-center my-3">
                                    <HelpImage6 />
                                </p>
                            </Typography>
                            <Typography component="li" className="bodyB2RegularText">
                                <p className="my-1">
                                    After defining the rule, choose the processor or processors for directing all transactions under this rule. You can also distribute traffic among multiple gateways by specifying the percentage for each.
                                </p>
                                <p className="text-center my-3">
                                    <HelpImage7 />
                                </p>
                            </Typography>
                            <Typography component="li" className="bodyB2RegularText">
                                <p className="mt-1 mb-5">
                                    You can also include fallback processors, so if any transaction fails with your chosen processor, it will automatically be routed to a fallback processor. Additionally, you can add multiple processors and set their priority order.                                </p>

                            </Typography>
                        </ol>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default HelpModal;
